module.exports = __webpack_public_path__ + "static/img/commitment-4_light.e6b4fbc7.png";